import BusinessReports from './BusinessReports';

export default BusinessReports;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/business-reports/index.js